import { render, staticRenderFns } from "./yaofang.vue?vue&type=template&id=610980c5&scoped=true&"
import script from "./yaofang.vue?vue&type=script&lang=js&"
export * from "./yaofang.vue?vue&type=script&lang=js&"
import style0 from "./yaofang.vue?vue&type=style&index=0&id=610980c5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610980c5",
  null
  
)

export default component.exports